module.exports = __webpack_public_path__ + "static/media/personalwebsite.a4cd3b16.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/personalwebsite.png
// module id = 82
// module chunks = 0